import { render, staticRenderFns } from "./EditCustomerFeePopup.vue?vue&type=template&id=b0f322b4&"
import script from "./EditCustomerFeePopup.vue?vue&type=script&lang=js&"
export * from "./EditCustomerFeePopup.vue?vue&type=script&lang=js&"
import style0 from "./EditCustomerFeePopup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports